import BaseAPI from './base'

class TeacherAPI extends BaseAPI {}

export default new TeacherAPI('v1/teachers', 'Teacher')
